export default "__VITE_ASSET__fujqTCL8ClNI8tLIUSeVgg__"